import { render, staticRenderFns } from "./NivelFornecedorTabela.vue?vue&type=template&id=cbee31d4&lang=html"
import script from "./NivelFornecedorTabela.vue?vue&type=script&lang=js"
export * from "./NivelFornecedorTabela.vue?vue&type=script&lang=js"
import style0 from "./NivelFornecedorTabela.vue?vue&type=style&index=0&id=cbee31d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports